module.exports = __webpack_public_path__ + "static/media/image-004n.391fedf3.jpeg";